import React from "react";
import { useRoutes, useInterceptor } from "hookrouter";
import AppHome from "../pages/home";
import AppDiensten from "../pages/diensten";
import AppOverOns from "../pages/over-ons";
import AppContact from "../pages/contact";
import { App404 } from "../pages";

const routes = {
  "/": () => <AppHome />,
  "/diensten": () => <AppDiensten />,
  "/over-ons": () => <AppOverOns />,
  "/contact": () => <AppContact />,
};

const App = () => {
  useInterceptor((_currentPath, nextPath) => {
    window.scrollTo(0, 0);
    window.dataLayer.push({
      event: "pageview",
    });
    return nextPath;
  });

  const routeResult = useRoutes(routes);
  return routeResult || <App404 />;
};

export default App;
